import { yupResolver } from "@hookform/resolvers/yup";
import { filtersValidation } from "../filters.validation";

export const validation = yupResolver(filtersValidation);
